import { LayerItem, LayerType } from 'src/types/layer'
import { formatCount } from './formatCount'

/** Why the clip output type can't be changed, or null when it can — mirrors the backend 400/409. */
export const clipOutputLockReason = (layer: LayerItem): string | null => {
  if (layer.type === LayerType.VECTOR) return 'Vector file — can only be clipped to vector'
  const clipped = layer._count.projectLayerUploads
  if (clipped === 0) return null
  const mode = layer.clipOutputType === LayerType.RASTER ? 'Raster' : 'Vector'
  const projects = clipped === 1 ? 'that project' : 'those projects'
  return `Already clipped as ${mode} into ${formatCount(clipped, 'project')}. Remove it from ${projects} to change`
}
